import React, {
  Component,
} from 'react';
import {
  Button,
  Container,
  Dimmer,
  Divider,
  Grid,
  Header,
  Icon,
  Loader,
  Segment,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import clone from 'clone';
import { push } from 'react-router-redux';
import { flashErrorMessage, flashSuccessMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import config from '../../../config';
import Identity from '../../components/Identity';
import NavBar from '../../components/NavBar';
import IncomeForm from '../CreditCheck/IncomeForm';


export default class EditIncome extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    routeParams: PropTypes.shape({
      id: PropTypes.string,
      incomeID: PropTypes.string,
    }),
  }
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      token: null,
      data: null,
      oriData: null,
      errMessages: [],
    };
    this.validation = {};
  }
  componentDidMount() {
    this.fetchIncome();
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, res);
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, res);
    });
  }
  async fetchIncome() {
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/customers/${this.props.routeParams.id}/income/${this.props.routeParams.incomeID}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const data = await res.json();
      // handle token.. etc
      await this.setComponentState({
        token,
        data,
        oriData: clone(data),
      });
    }
    await this.setLoading(false);
  }
  async updateIncome(validations, income) {
    event.preventDefault();
    const { store } = this.context;
    const errors = validations.filter(v => !v.isValid);
    if (errors.length > 0) {
      store.dispatch(flashErrorMessage({ header: 'Please fix form errors', list: errors.map(l => l.message) }));
      return;
    }
    await this.setLoading(true);
    try {
      await this.form.submit(`${config.get('bookApiURL')}/customers/${this.props.routeParams.id}/income/${this.props.routeParams.incomeID}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
        body: JSON.stringify(income),
      });
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    await this.setLoading(false);
    store.dispatch(push(`/customers/${this.props.routeParams.id}/`));
    store.dispatch(flashSuccessMessage({ header: 'Update Successs', message: 'Customer income has been successfully updated' }));
  }
  render() {
    const { data } = this.state;
    return (
      <Container>
        <NavBar
          header="Income"
        />
        <Segment className="dark credit-check" color="grey" inverted secondary textAlign="center">
          <Grid textAlign="center">
            <Grid.Row>
              <Grid.Column>
                <Divider horizontal inverted>Update Income</Divider>
                {
                  data &&
                  data.customer &&
                  data.customer.customerDetail ?
                    <Header
                      as="h1"
                      textAlign="center"
                      style={{ marginBottom: '1em' }}
                      content={data.customer.customerDetail.preferredName || 'Customer'}
                      subheader={
                        <Header.Subheader>
                          <p style={{ marginBottom: '0' }} >
                            {data.customer.customerDetail.name}
                          </p>
                          <Identity
                            type={data.customer.identityTypeID}
                            identity={data.customer.identity || 'XXXXXXXXXXXX'}
                          />
                        </Header.Subheader>
                      }
                    /> :
                  null
                }
                <Dimmer active={this.state.loading} inverted>
                  <Loader inline="centered">Loading</Loader>
                </Dimmer>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                {
                data ?
                  <Grid.Column>
                    <IncomeForm
                      ref={(ref) => { this.form = ref; }}
                      onSubmit={(validations, d) => {
                        this.updateIncome(validations, d);
                      }}
                      income={data}
                      onChange={this.handleIncomeChange}
                      isEditing
                    />
                    <Button
                      size="large"
                      color="green"
                      type="submit"
                      disabled={this.state.loading}
                      style={{
                        marginTop: '2em',
                        marginBottom: '1.5em',
                      }}
                      onClick={
                        () => { this.form.handleSubmit(event); }
                      }
                    >
                      <Icon name="save" /> Update
                    </Button>
                  </Grid.Column> :
                  (
                    <Grid.Column>
                      {
                        !this.state.loading ?
                          <p>No income found.</p>
                        : ''
                      }
                    </Grid.Column>
                  )
              }
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Customers/EditIncome.jsx